import React, { useEffect, useState } from "react";
import { useLocation, Link, useParams, useNavigate } from "react-router-dom";
import "./Support.css";
import search from "../../assets/images/searchi.svg";
import { Routers } from "../../routes/Constant";
import { useDispatch, useSelector } from "react-redux";
import { supportTranning } from "../../redux/slice/InstructorSlice";
import VideoPlayer from "./VideoPlayer";

const SupportDetails = () => {
  const location = useLocation();
  const params = useParams();
  const paramsstr = params?.type?.[0]?.toUpperCase() + params?.type?.slice(1);
  const [currentArticle, setCurrentArticle] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredArticles, setFilteredArticles] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Handle back button navigation
  useEffect(() => {
    const handleBackButton = () => {
      navigate(Routers.support);
    };

    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, [navigate]);

  // Dispatch support training data based on params
  useEffect(() => {
    if (params?.type) {
      dispatch(supportTranning(params?.type));
    }
  }, [dispatch, params?.type]);

  const response = useSelector((state) => state?.instructors?.tranning);

  // Filter articles based on search term
  useEffect(() => {
    if (searchTerm) {
      const filtered = response?.[0]?.filter((article) =>
        article?.title?.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredArticles(filtered);
    } else {
      setFilteredArticles([]);
    }
  }, [searchTerm, response]);

  // Determine the current article to display
  useEffect(() => {
    if (Array.isArray(response?.[0])) {
      const articles = response[0];
      const articleId = params?.articleId;
      
      if (articleId) {
        const article = articles.find(
          (article) => article.id.toString() === articleId.toString()
        );
        setCurrentArticle(article || articles[0]); // Fallback to the first article if not found
        setSearchTerm("")
      } else {
        setCurrentArticle(articles[0]);
      }
    }
  }, [navigate]);
  

  const showDetailedContent = location.pathname.includes("/support-list");

  return (
    <section className="keyzi_support--wrapper keyzi_supportDetail--wrapper">
      <div className="container">
        <div className="keyzi_support--inner">
          <div className="detail-head">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to={Routers?.support}>Keyzi Support</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  {paramsstr}
                </li>
              </ol>
            </nav>
            <div className="search-wrapper">
              <img src={search} alt="search" />
              <input
                type="search"
                className="form-control"
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e?.target.value)}
              />
              {Array.isArray(filteredArticles) && filteredArticles.length > 0 && (
                <ul className="article-list-wrapper">
                  {filteredArticles.map((article, index) => {
                    const title = article?.title || "";
                    const regex = new RegExp(`(${searchTerm})`, "gi");
                    const parts = title.split(regex);

                    return (
                      <li key={index}>
                        <Link
                          to={`/xcsfvt/support-content/learner/${
                            article?.id || index
                          }`}
                          className="text-capitalize"
                        >
                          {parts.map((part, idx) =>
                            part.toLowerCase() === searchTerm.toLowerCase() ? (
                              <strong key={idx}>{part}</strong>
                            ) : (
                              part
                            )
                          )}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <ul>
                <li>Articles in this section</li>
                {Array.isArray(response?.[0]) &&
                  response?.[0]?.map((article, index) => (
                    <li key={index}>
                      <Link
                        className="text-capitalize"
                        to={`/xcsfvt/support-content/${params?.type}/${article?.id}`}
                      >
                        {article?.title}
                      </Link>
                    </li>
                  ))}
              </ul>
            </div>
            <div className="col-md-8">
              {showDetailedContent ? (
                <h3>No Article Found</h3>
              ) : (
                <div className="rs-content detail-content">
                  <h3 className="text-capitalize">{currentArticle?.title}</h3>
                  <p>Information & support for {paramsstr}</p>
                  <VideoPlayer src={currentArticle?.path} />
                  <div className="row">
                    <div className="col-md-12">
                      <div className="content-wrapper">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: currentArticle?.description,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SupportDetails;
